<vb-loading-spinner *ngIf="status.isLoading; else active;" [block]="true" [size]="'medium'">
</vb-loading-spinner>
<ng-template #active>
	<ng-container *ngIf="(EventAnalyticsService.liveEventsContext$ | async) as liveEventsCtx">
		<div [hidden]="!liveEventsCtx.searchQuery && !liveEventsCtx.displayCount">
			<h1 class="margin-0">{{ 'Event_Analytics_LiveEvents_Header' | translate }}</h1>
			<vb-ui-report-cell class="width-full position-relative margin-top-10" [ngClass]="styles.liveEventsReportCell" [header]="'Event_Analytics_LiveEvents_Count_Header' | translate : { '0': liveEventsCtx.displayCount, '1': liveEventsCtx.totalCount }" [headerTag]="'h2'" [size]="'large'">
				<live-events-grid [accountId]="accountId" [pollingIntervalSecs]="eventsPollingIntervalInSecs">
				</live-events-grid>
			</vb-ui-report-cell>
		</div>
	</ng-container>
	<report-tab-content [header]="'Event_Analytics_Header' | translate : {'0': (AnalyticsService.dateFilter$ | async)?.label }" [headerTag]="'h1'" [showDateFilter]="true">
		<event-analytics-kpis [data]="kpis$ | async"></event-analytics-kpis>

		<div layout="row">
			<vb-ui-report-cell class="width-full" [header]="'Attendees' | translate" [headerTag]="'h3'" [noHeaderBottomBorder]="true" [size]="'large'">
				<event-analytics-attendees-chart *ngIf="(attendeesByEvent$ | async) as attendeesByEvent" [data]="attendeesByEvent">
				</event-analytics-attendees-chart>
			</vb-ui-report-cell>
		</div>
		<events-grid layout="row" [accountId]="accountId" [dataFetchContext]="AnalyticsService.dataFetchContext$ | async" [header]="'Events' | translate">
		</events-grid>
	</report-tab-content>
</ng-template>
